import React from 'react';

interface ThemeSectionProps {
  /** Lets the section nav scroll to it */
  id: string;
  title: string;
  children: React.ReactNode;
}

const ThemeSection: React.FC<ThemeSectionProps> = ({ id, title, children }) => (
  <section className="theme-section" id={id}>
    <h3>{title}</h3>
    <div className="theme-section-content">
      {children}
    </div>
  </section>
);

export default ThemeSection;
